import React from 'react';
import './DeliveryPopupModalContentStyle.css';
import couponsClient from '../../logic/coupons';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import { useTranslation } from 'react-i18next';

export default function CouponModalContent(props) {
    const { onClickHandler, setCouponSentinel } = props;

    const [coupon, setCoupon] = React.useState();
    const [acceptedCoupon, setAcceptedCoupon] = React.useState();

    const { t } = useTranslation();
    const { restaurant } = useRestaurant();

    function checkHandler() {
        const res = couponsClient.getCoupon(coupon, restaurant);

        if (res.accepted && String(res.restaurantAccepted) === String(restaurant.id)) {
            setAcceptedCoupon(true);
            sessionStorage.setItem('coupon', JSON.stringify(res));
            setCouponSentinel(true);
            onClickHandler();
        } else {
            setAcceptedCoupon(false);
        }
    }

    return (
        <div className="coupon-modal-content overflow-auto text-black ">
            <div className="px-3 py-8 text-center">
                <p>{t("cart.coupon.p_1")}</p>
                <input onChange={(e) => setCoupon(e.target.value)} placeholder={t("cart.coupon.input")} className="w-2/3 m-1 p-2 rounded-lg bg-grey-200" />
                <button onClick={checkHandler} className="p-2 border border-mycia-green rounded-lg">{t("cart.coupon.button_1")}</button>
                {!acceptedCoupon ? <p className="text-red-600">{t("cart.coupon.p_2")}</p> : null}
            </div>
            <div className="fixed bottom-0 py-2 bg-mycia-green rounded-b-lg w-full">
                <button className="w-full" onClick={onClickHandler}>{t("cart.coupon.button_2")}</button>
            </div>
        </div>
    );
}
